var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CSidebar',{attrs:{"fixed":"","minimize":_vm.minimize,"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{staticClass:"c-sidebar-brand"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/img/logo.png","width":"118","height":"46","alt":"Logo"}})])],1),_c('MenuItems')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }